import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { Challenges } from 'src/models/Challenges';
import { CardActivities } from 'src/models/CardActivities/CardActivities';
import { STORE_NAME } from 'src/utils/constants';
import { handleStateError } from 'src/errors';
import { RootStore } from './RootStore';

export default class ActivitiesStore {
  private storeName = STORE_NAME.ACTIVITIES_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;
  activities?: Challenges[];
  cardActivities?: CardActivities;

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  loadActivities = async (): Promise<Challenges[] | undefined> => {
    try {
      const activities = await this.apiService.getActivities();

      if (activities) {
        runInAction(() => {
          this.activities = activities;
        });
      }

      return this.activities || [];
    }
    catch (error) {
      handleStateError(error, this.storeName);
    }
  };

  loadCardActivities = async (): Promise<CardActivities | undefined> => {
    try {
      const cardActivities = await this.apiService.getCardActivities();

      if (cardActivities) {
        runInAction(() => {
          this.cardActivities = cardActivities;
        });
      }

      return this.cardActivities;
    }
    catch (error) {
      handleStateError(error, this.storeName);
    }
  };
}
